import { DetailsItem } from '@src/orders/components/DetailsItem';
import { UpdatableValue } from '@src/orders/components/UpdatableValue';

type Props = {
  itemName: string;
  value?: string;
  lastUpdated?: string;
  valueEmphasis?: boolean;
};
export const UpdatableDetailsItem = ({
  itemName,
  value,
  lastUpdated,
  valueEmphasis,
}: Props) => {
  const valueWithIcon = (
    <UpdatableValue lastUpdated={lastUpdated} variant="inherit">
      {value}
    </UpdatableValue>
  );
  return (
    <DetailsItem
      itemName={itemName}
      value={valueWithIcon}
      valueEmphasis={valueEmphasis}
    />
  );
};
